/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData model module.
 * @module model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData
 * @version 1.0
 */
class MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData {
    /**
     * Constructs a new <code>MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData</code>.
     * @alias module:model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData
     */
    constructor() { 
        
        MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData} The populated <code>MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('eventNo')) {
                obj['eventNo'] = ApiClient.convertToType(data['eventNo'], 'Number');
            }
            if (data.hasOwnProperty('logType')) {
                obj['logType'] = ApiClient.convertToType(data['logType'], 'Number');
            }
            if (data.hasOwnProperty('point')) {
                obj['point'] = ApiClient.convertToType(data['point'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} logNo
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} eventNo
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['eventNo'] = undefined;

/**
 * @member {Number} logType
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['logType'] = undefined;

/**
 * @member {Number} point
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['point'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData.prototype['createdAt'] = undefined;






export default MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData;

